import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { format } from "date-fns";
import React from "react";
import { PreloadedQuery, usePreloadedQuery } from "react-relay";

import { Text, Box } from "@whoosh/design-system/src/components/primitive";
import { convertServerTimeToLocal } from "@whoosh/utilities/src/dates";

import { EventDetailCancelWindowQuery } from "./__generated__/EventDetailCancelWindowQuery.graphql";

type EventDetailCancelWindowProps = {
  eventSignUpQueryRef: PreloadedQuery<EventDetailCancelWindowQuery>;
  wrapperStyle?: any;
};

export const EventDetailCancelWindow = ({
  eventSignUpQueryRef,
  wrapperStyle,
}: EventDetailCancelWindowProps) => {
  const data = usePreloadedQuery<EventDetailCancelWindowQuery>(
    EventSignUpQueryString,
    eventSignUpQueryRef
  );

  const cancelDeadlineAt = data.node?.signUpWindow?.cancelDeadlineAt;

  const currentDate = new Date();
  const currentDateTime = format(currentDate, "yyyy-MM-dd HH:mm:ss");

  const formattedCancelDeadlineAt = cancelDeadlineAt
    ? format(convertServerTimeToLocal(cancelDeadlineAt), "yyyy-MM-dd HH:mm:ss")
    : null;

  const displayCancelDeadlineAt = cancelDeadlineAt
    ? format(convertServerTimeToLocal(cancelDeadlineAt), "MMM do 'at' h:mm aa")
    : null;

  const isInCancelWindowRange = formattedCancelDeadlineAt
    ? currentDateTime < formattedCancelDeadlineAt
    : true;

  return (
    <Box
      width="100%"
      bg={
        isInCancelWindowRange
          ? "surface-status-success-subtle"
          : "surface-status-warning-subtle"
      }
      justifyContent="center"
      alignContent="center"
      style={wrapperStyle}
    >
      {isInCancelWindowRange && formattedCancelDeadlineAt ? (
        <Text textAlign="center" color="text-primary" fontSize={10} padding={2}>
          {t`Cancellation available until`} {`${displayCancelDeadlineAt}`}
        </Text>
      ) : isInCancelWindowRange ? (
        <Text textAlign="center" color="text-primary" fontSize={10} padding={2}>
          {t`Cancellation available`}
        </Text>
      ) : (
        <Text
          textAlign="center"
          color="text-primary"
          fontSize={10}
          padding={2}
        >{t`Cancellation not allowed`}</Text>
      )}
    </Box>
  );
};

export const EventSignUpQueryString = graphql`
  query EventDetailCancelWindowQuery($eventSignUpId: ID!) {
    node(id: $eventSignUpId) {
      ... on EventSignUp {
        signUpWindow {
          cancelDeadlineAt
        }
      }
    }
  }
`;
